import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CurrentService } from '../../../services/current.service';
import { DatasService } from '../../../services/datas.service';
import { GTM } from 'src/app/services/gtm.service';
import { Router } from '@angular/router';
import { getHbmTotalSteps } from 'src/app/services/helpers/app-context-helper';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'ng-casto-kitchen-model',
  templateUrl: './model.component.html',
})
export class KitchenModelComponent implements OnInit {
  models: any;

  @Output() onComplete: EventEmitter<void> = new EventEmitter();
  constructor(
    public current: CurrentService,
    public datas: DatasService,
    public gtm: GTM,
    private readonly router: Router,
    private readonly customer: CustomerService
  ) {
    if (this.current.kitchen.styleId > 0) {
      this.models = datas.models.filter((m: any) => {
        if (!m.active) return false;
        return m.styleId === this.current.kitchen.styleId;
      });
    } else {
      this.models = datas.models.filter(m => m.active);
    }
  }

  selectModel(modelId: number) {
    this.current.kitchen.modelId = modelId;
    this.onComplete.emit();
  }

  ngOnInit(): void {
    this.gtm.trackPage(`${this.router.url}/choix/modele`, 'Cuisine | Choix', {
      stepNumber: 2,
      totalSteps: getHbmTotalSteps(this.customer.context),
    });
  }
}
